import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../Button';
import styled from 'styled-components';

interface IProps {
  goStudentInfo(): void;
  goAcceptance(): void;
  doGetStudentClassInfo: () => void;
}

const Block = styled.div`
  padding: 5rem 5rem 0;

  .title {
    text-align: center;
  }

  .buttons {
    width: 100%;
    align-items: center;
    justify-content: center;
    display: flex;
  }
`;

const ClassCompleteContents: FC<IProps> = ({
  goStudentInfo,
  goAcceptance,
  doGetStudentClassInfo,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    doGetStudentClassInfo();
  }, []);

  return (
    <Block>
      <p className="title">{t('student.student.text13')}</p>
      <div className="comm-btn__area justify-content-center">
        <Button
          className="btn-basic pink-line"
          onClick={goStudentInfo}
          text={t('student.student.button12')}
        />
        <Button
          className="btn-basic pink-line"
          onClick={goAcceptance}
          text={t('student.student.button13')}
        />
      </div>
    </Block>
  );
};

export default ClassCompleteContents;
